export default class AbstractReviewForm {
	_errors = [];

	constructor($context) {
		this.$context = $context;
	}

	get $form() {
		return this.$context.find('.review-form__form');
	}

	get errors() {
		return this._errors;
	}

	set errors(errors) {
		this._errors = errors;

		const $error = this.$context.find('.review-form__error');
		$error.html('');
		const $formgroups = this.$context.find('.formgroup');
		$formgroups.removeClass('formgroup--error');
		this.errors.forEach(error => {
			if (typeof error === 'string') {
				$error.append($('<div/>').html(error));
			} else {
				const { field, message } = error;
				const $formgroup = $formgroups.filter(`[data-field="${field}"]`);
				if (field === 'captcha') {
					this.$context.find('.wa-captcha-refresh').trigger('click');
				}
				if ($formgroup.length) {
					let $formgroup_error = $formgroup.find('.formgroup__error');
					if (!$formgroup_error.length) {
						$formgroup_error = $('<div class="formgroup__error"/>');
						$formgroup.append($formgroup_error);
					}
					$formgroup_error.html(message);
					$formgroup.addClass('formgroup--error');
					$formgroup.find('input, textarea').trigger('focus');
				} else {
					$error.append($('<div/>').html(message));
				}
			}
		});

		this.$context.toggleClass('review-form_error', this.errors.length > 0);
	}

	/**
	 * @return {FormData}
	 */
	get form_data() {
		return new FormData(this.$form[0]);
	}

	get form_url() {
		return this.$form.attr('action');
	}
}
